import {
  instancesStore,
  translationsStore,
  filterStore,
  sidebarStore,
  scenarioStore,
  wizardStore
} from 'state'
import {
  getInstances,
  getScenarioInstances,
  getWorkingTables,
  getDocumentCount,
  getTranslations
} from 'api/instances'
import { canRead } from 'services/auth'
import { fetchConfig } from 'services/api/config'
import { mapInstance, mapTranslationsTableWithT } from './utils'
import { fetchMyPermissions } from 'services/api/scenarios'
import { map, some } from 'lodash'

export async function updateInstanceWorkingTableCount() {
  const wtIDs = sidebarStore.get((store) => store.items).map((wt) => wt.id)
  const wtCounts = await getDocumentCount(wtIDs)
  sidebarStore.update((store) => ({
    ...store,
    items: store.items.map((wt) => ({
      ...wt,
      count: wtCounts[wt.id] || null
    }))
  }))
}

export async function getTranslationsTableFromIstanceID(t) {
  translationsStore.set(Array.from({ length: 5 }).fill({ loading: true }))
  const translations = await getTranslations()

  if (!translations) {
    resetSidebarStore()
    return
  }

  const {
    body: { items }
  } = translations

  const mapTranslationsTable = mapTranslationsTableWithT(t)

  const tls = items.map((tl) => mapTranslationsTable(tl))
  translationsStore.set(tls)
  sidebarStore.set({ type: 'translations', items: tls })

  return tls
}

export async function getWorkingTablesFromIstanceID(instanceID) {
  sidebarStore.set({ items: Array.from({ length: 5 }).fill({ loading: true }) })
  const workingTables = await getWorkingTables(instanceID)

  if (!workingTables) {
    resetSidebarStore()
    return
  }

  const {
    body: { items }
  } = workingTables

  const readableWts = items.filter(({ permission }) => canRead(permission))

  const wtIDs = readableWts.map((wt) => wt.id)
  const wtCounts = await getDocumentCount(wtIDs)

  return { wts: readableWts, wtCounts }
}

function mergeInstances(instances, scenarioInstances) {
  if (scenarioInstances && (!instances || !instances.body))
    return scenarioInstances

  if (instances && (!scenarioInstances || !scenarioInstances.body))
    return instances

  instances.body.items = instances.body.items?.concat(
    scenarioInstances.body?.items
  )

  return instances
}

export async function getInstancesList() {
  const instances = await getInstances()

  const scenarioInstances = await getScenarioInstances()
  if (
    (!instances || !instances.body) &&
    (!scenarioInstances || !scenarioInstances.body)
  ) {
    instancesStore.set([])
    return
  }

  const allInstances = mergeInstances(instances, scenarioInstances)

  setInstances(allInstances)
}

export const setInstances = (data) => {
  const {
    body: { items }
  } = data

  const instances = items
    .filter(({ permission }) => canRead(permission))
    .map(mapInstance)

  instancesStore.set(instances)
}

const updateFilterStore = (updaterFn) => {
  filterStore.update(updaterFn)
}

const resetFilterStore = () => {
  filterStore.set({})
}

const setFilterStore = (value) => {
  filterStore.set(value)
}

const updateWizardStore = (updaterFn) => {
  wizardStore.update(updaterFn)
}

export const FiltersActions = {
  update: updateFilterStore,
  set: setFilterStore,
  reset: resetFilterStore
}

export const WizardActions = {
  update: updateWizardStore
}

export const fetchAppConfig = () => {
  const configs = ['model', 'scenario', 'output']
  return Promise.all(configs.map(fetchConfig))
}

export const getMyScenarioPermissions = async () => {
  const myPermissions = await fetchMyPermissions()

  const permissions = {
    owner: some(map(myPermissions.owner), (owner) => owner),
    others: some(map(myPermissions.others), (others) => others),
    ownerByScenarioType: myPermissions.owner
  }

  scenarioStore.update((prev) => ({ ...prev, permissions }))
}

const setSidebarStore = (value) => {
  sidebarStore.set(value)
}

export const resetSidebarStore = () => sidebarStore.set({ items: [] })

export const __unsafeSidebarActions = {
  set: setSidebarStore,
  reset: resetSidebarStore
}
